import React, { FunctionComponent, useRef,useEffect } from "react";
import { useState } from "react";
// import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
// import { AiOutlineClose } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
// import { fetchFAQ } from "../../Services/resources";
import { createFAQ } from "../../Services/faq";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { googleAnalytics } from "../../Services/users";

type props = {
  history: any;
  user: any;
  theme: any;
  authToken: any;
};
const AddFAQ: FunctionComponent<props> = ({ history, user, theme,authToken }) => {
  const [load, setLoad] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  // const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const dispatcher = useDispatch();
  const questionRef: any = useRef();
  const answerRef: any = useRef();
  const [isGACalled, setIsGACalled] = useState<any>(false);

  // useEffect(() => {
  //   if (user.organization_id) {
  //     fetchFAQ(user.organization_id, (data) => setfaqList(data));
  //   }
  // }, [user]);

  const handleCheck = () => {
    if (questionRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Question!!", "error"));
      return false;
    } else if (answerRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Answer!!", "error"));
      return false;
    }
    // else if (srNumberRef.current.value === "") {
    //   dispatcher(showSnackbarAction("Please Enter Serial Number!!", "error"));
    //   return false;
    // }
    // else if (srNumberRef.current.value) {
    //   const numberS = faqList?.some(m => m.serialNumber === srNumberRef.current.value);
    //   if (numberS) {
    //     dispatcher(showSnackbarAction("Serial Number already exists  !!", "error"));
    //     return false;
    //   }
    //   return true;
    // }
     else {
      return true;
    }
  };
  const create = (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    if (val) {
      setLoad(true);
      createFAQ(
        user.organization_id,
        questionRef.current.value,
        answerRef.current.value,
        dispatcher,
        (data: boolean) => setLoad(data),
        user.uid,
        authToken,
        history
      );
    }
  };
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Add_FAQ_Screen',user)
      }
    }
  },[user])
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className="container-fluid p-4 d-flex flex-column gap-4" style={containerStyles}>
      <h3>Add FAQ</h3>
      <div className="w-100 d-flex flex-column gap-2" style={cardContainerStyles}>
        <form className="card p-4 shadow rounded" style={cardContainerStyles}>
        <div className="mb-3">
            <Label label="Question" required />
            <input
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              ref={questionRef}
              onChange={(e) => setQuestion(e.target.value)}
              value={question}
            />
          </div>
         {/* <div style={{display:'flex',justifyContent:"space-between",gap:"0.5rem"}}>
          <div className="mb-3 col-0.4">
            <Label label="S.NO" required />
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
            aria-describedby="emailHelp"
            ref={srNumberRef}
            onChange={(e) => setSNumber(e.target.value)}
            value={sNumber}
            />
          </div>
          </div> */}
          <div className="mb-3">
            <Label label="Answer" required />
            <textarea
              className="form-control"
              id="exampleInputPassword1"
              rows={5}
              ref={answerRef}
              onChange={(e) => setAnswer(e.target.value)}
              value={answer}
            />
          </div>
          <button
            type="submit"
            // className="btn btn-primary mt-5"
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            onClick={(e) => create(e)}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(AddFAQ);